"use client";

import type { FC } from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { EdMarkLarge } from "../quiz/EdHeroBubble";
import { QuizProgressHeader, QuizStepLayout } from "../quiz/QuizStepLayout";
import { LOADER_COPY } from "../onboardingWizardCopy";

interface LoaderErrorStepProps {
  onRetry: () => void;
}

export const LoaderErrorStep: FC<LoaderErrorStepProps> = ({ onRetry }) => (
  <QuizStepLayout
    testId="onboarding-loader-error-step"
    header={
      <QuizProgressHeader
        progressIndex={0}
        progressTotal={0}
        showProgress={false}
        onBack={onRetry}
      />
    }
  >
    <div
      className="flex flex-1 flex-col items-center px-6 pt-8 md:px-0"
      data-figma-node="96177:12267"
      data-figma-node-pc="96344:110581"
    >
      <EdMarkLarge className="mt-8" />
      <h2 className="headline_regular_m mt-6 text-content_inverse_primary">
        {LOADER_COPY.errorTitle}
      </h2>

      <div className="mt-10 w-full max-w-[300px] rounded-xl bg-content_secondary p-5">
        {LOADER_COPY.rows.map((row, index) => {
          const status = index < 2 ? "done" : index === 2 ? "error" : "pending";
          return (
            <div
              key={row}
              className={cn(
                "flex items-center justify-between gap-3 py-2.5",
                status === "pending" && "opacity-40",
              )}
            >
              <p className="body_medium_m text-content_inverse_primary">
                {row}
              </p>
              <div className="relative size-[22px] shrink-0">
                {status === "done" ? (
                  <div className="flex size-[22px] items-center justify-center rounded-full bg-content_aura_lv3_primary">
                    <Icon
                      name="check"
                      size={14}
                      className="text-content_brand_primary"
                    />
                  </div>
                ) : status === "error" ? (
                  <div className="flex size-[22px] items-center justify-center rounded-full bg-content_accent4_primary">
                    <span className="text-xs text-content_inverse_primary">
                      !
                    </span>
                  </div>
                ) : (
                  <div className="size-[22px] rounded-full border border-white/30" />
                )}
              </div>
            </div>
          );
        })}
      </div>

      <p className="body_medium_s mt-6 max-w-[300px] text-center text-white/60">
        {LOADER_COPY.errorHint}
      </p>

      <button
        type="button"
        data-testid="loader-retry-button"
        className="button md_button inverse_button mt-4 min-w-[156px] rounded-lg px-4 py-3 button_m text-content_primary"
        onClick={onRetry}
      >
        {LOADER_COPY.retry}
      </button>
    </div>
  </QuizStepLayout>
);
